export default {
    intro: ({ values }: { values: { isAuto: boolean; questionTime: number; answerTime: number } }) => {
        const { isAuto, questionTime, answerTime } = values;
        if (isAuto) {
            return `Check the question for ${answerTime} seconds, then choose true or false in ${questionTime} seconds!`;
        } else {
            return 'Look at the question and choose O or X!';
        }
    },
    options: {
        auto: 'Auto Progress',
        manual: 'Manual Progress',
        timer: 'Timer Settings',
        answerTime: 'Question Review Time',
        questionTime: 'Answer Selection Time',
        answerCheckTime: 'Answer Check Time',
        showOtherAvatar: 'Show All Avatars',
        showOtherAvatarDescription: 'Choose whether to show other Students\' Avatars on the Student screen during OX selection.',
    },
    topbar: {
        check: 'Please check the question.',
        question: 'Please select the correct answer.',
        result: 'Correct answer revealed!',
        default: 'Fun OX Quiz',
    },
    buttons: {
        standby: 'Reveal Question',
        question: 'Close Selection & Reveal Answer',
        check: 'Start Selecting',
        unclickUser: {
            unselect: 'View<br />Unselected',
            allSelect: 'Everyone<br />has selected!',
            count: '{count} students',
        },
    },
    modal: {
        unselect: 'Students who haven\'t selected',
        timerError: 'To start the OX Quiz in auto mode,<br>please set all 3 timers.',
    },
    toast: {
        unselect: 'Check the question before choosing your answer!',
    },
    standbyStep: ({ values }: { values: { index: number } }) => {
        const { index } = values;
        const messages = ['Inflating<br />the balloon...', 'Warming up<br />the hot air balloon...', 'Performing<br />safety check...'];
        return messages[index];
    },
    resultStep: {
        result: 'The correct answer is <i></i>.',
        nextQuestion: 'Next question starts in {time} seconds!',
    },
    autoMode: 'Running in auto mode.',
    questionAccuracy: {
        content: ({ values }: { values: { questionText: string; correctChoice: boolean } }) => {
            const { questionText, correctChoice } = values;
            return `${questionText} <strong>${correctChoice ? '(O: True)' : '(X: False)'}</strong>`;
        },
    },
    correctChoice: {
        true: 'True',
        false: 'False',
    },
    question: 'Question',
    answer: 'Correct Answer',
    explanation: 'Explanation',
    additionalMaterial: 'Additional Resources',
    explanationMaterial: 'Explanation Resources',
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
    },
    isAnswer: 'What is the answer?',
    roundNumber: 'No. {number}',
    timer: {
        remaining: '{count}s',
    },
};
